import React, { useState, useCallback } from 'react';

import { Accordion } from 'react-bootstrap';
import Info from '../components/Info/Info';
import { Icon } from 'lb-components';
import {
  Back,
  IdLogos,
  Map,
  Video,
} from 'lb-components/src/stories/assets/icons/payment';

import classes from '../components/Info/Info.module.scss';
import { UseNavigation } from 'lb-store/src/hooks';
const withdrawFee = 6;
const entries = [
  /*{
    key: 'Bog',
    video: '//www.youtube.com/embed/1ggxo9qM1MU',
    map: { url: 'https://bankofgeorgia.ge/ka/locations', external: true },
    content:
      'გაიტანე თანხა საქართველოს ბანკის ბანკომატებიდან და სალაროებიდან მარტივად ID ბარათის მეშვეობით',
    limit: { min: '1', max: '5 000', fee: '3' },
  },*/
  {
    key: 'Lib',
    video: '//www.youtube.com/embed/qKDbQaqxinU',
    map: {
      url: 'https://www.libertybank.ge/ka/chven-shesakheb/kompaniis-shesakheb/bankomatebi',
      external: true,
    },
    content:
      'გაანაღდეთ ლიდერბეთის ანგარიშებზე არსებული ტანხა ლიბერთი ბანკის ბანკომატებიდან თქვენი eID და PAY ბარათის მეშვეობით.',
    limit: { min: '1', max: '3 000', fee: withdrawFee },
  },
];

export default ({ platform, actionType, t, ...props }) => {
  const [videoSrc, setVideoSrc] = useState(null);
  const { navigate } = UseNavigation();

  const header = useCallback(
    (item) => (
      <>
        <span
          onClick={(e) => {
            e.stopPropagation();
            if (item.map.external) window.open(item.map.url);
            else navigate(item.map.url);
          }}
          style={{
            textDecoration: 'underline',
            display: 'flex',
            marginRight: '1.8rem',
          }}
        >
          <Icon
            height={'2.5rem'}
            width={'1.9rem'}
            Icon={Map}
            style={{ marginRight: '1rem' }}
          />
          {t('სალაროები')}
        </span>
        <span
          onClick={(e) => {
            e.stopPropagation();
            setVideoSrc(item.video);
          }}
          style={{
            textDecoration: 'underline',
            display: 'flex',
            marginLeft: '1.8rem',
          }}
        >
          <Icon
            height={'3rem'}
            width={'2.1rem'}
            Icon={Video}
            style={{ marginRight: '1rem' }}
          />
          {t('ვიდეო ინსტრუქცია')}
        </span>
      </>
    ),
    []
  );
  return (
    <Accordion>
      {videoSrc ? (
        <>
          <span
            onClick={() => {
              setVideoSrc(null);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              color: '#454A65',
              fontFamily: 'lbet-st',
              fontSize: '1.5rem',
              cursor: 'pointer',
              margin: '1.5rem',
              position: 'absolute',
              top: 0,
              right: 0,
              transform: 'translateY(-220%)',
            }}
          >
            <Icon
              height={'1.9rem'}
              width={'2.4rem'}
              Icon={Back}
              style={{ marginRight: '1rem' }}
            />
            უკან გასვლა
          </span>
          <div
            style={{
              aspectRatio: '16/9',
              position: 'relative',
            }}
          >
            <iframe
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              src={videoSrc}
              frameBorder={0}
              allowFullScreen
            />
          </div>
        </>
      ) : (
        entries.map((item) => (
          <Info
            platform={platform}
            t={t}
            limit={item.limit}
            key={item.key}
            eventKey={item.key}
            actionType={actionType}
            {...(platform === 'web' && { header: header(item) })}
            content={
              <>
                {platform === 'mob' && (
                  <div
                    className={classes.details}
                    style={{
                      justifyContent: 'space-around',
                      width: 'calc(100% + 2.5rem)',
                      marginLeft: '-1.25rem',
                      marginBottom: '1.5rem',
                      backgroundColor: '#F5F5F5',
                      padding: '1rem',
                      borderRadius: '4px',
                    }}
                  >
                    {header(item)}
                  </div>
                )}
                <div>{t(item.content)}</div>
              </>
            }
            logo={IdLogos[item.key]}
            style={{ margin: '1rem 0' }}
          />
        ))
      )}
    </Accordion>
  );
};
